import React from "react";
import { useCelebrityHomeAPI } from '../../hooks/useAllCategoryData';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
const CelebrityScroll = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };
 const { isLoading, error, data } = useCelebrityHomeAPI();
     if (error) return <div>{error.message}</div>; 
     //console.log(data?.celebrity)
  return (
    <div className="celebrity-full">
      <div className="container">
        <h2 className="newfont-heading">सेलिब्रिटीज in Chaashni{/* Celebs in Chaashni Couture */}</h2>
         {isLoading && (
          <div className='loading-div'><span>Loading...</span></div>
        )}
        {data?.celebrity?
        <div className="celebrity-slider">
          <Carousel
            showDots={false}
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            infinite={true}
            //autoPlay={this.props.deviceType !== "mobile" ? true : false}
            autoPlaySpeed={1000}
            //keyBoardControl={true}
            //customTransition="all .5"
            transitionDuration={500}
            containerClass="carousel-container"
            //removeArrowOnDeviceType={["tablet", "mobile"]}
            //deviceType={this.props.deviceType}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-30-px">
              {data?.celebrity?.map((e, i) => (
              <div className="celeb-item" key={i}>
                <img src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/celebrity_gallery/${e.show_homepage	}`} alt={e.name} />
                  <div className="celeb-name">{e.name}</div>
              </div>
            ))}                       
          </Carousel>
        </div>
        :'' }
      </div>
    </div>
  );
};

export default CelebrityScroll;
